import { mapGetters } from 'vuex'
import SiteSearchGroup from '@/components/search-group'
import { PUBLISHER_DICT_OPTION } from '@/utils/dict'
import { settingOption } from '@/api/setting'
import addDialog from './add.dialog.vue'

const columns = [
  {
    title: '',
    enTitle: 'Option Name',
    width: 180,
    dataIndex: 'name',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Other Name',
    width: 200,
    dataIndex: 'otherName',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Description',
    width: 180,
    dataIndex: 'info',
    slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Status',
    width: 100,
    dataIndex: 'enabled',
    slot: 'status'
  },
  {
    title: '',
    enTitle: 'Operator',
    width: 200,
    dataIndex: 'operator',
    slot: 'name'
  },
  {
    title: '',
    enTitle: 'Operator Email',
    width: 200,
    dataIndex: 'operator',
    slot: 'email'
  },
  {
    title: '',
    enTitle: 'Operated Time',
    width: 200,
    dataIndex: 'operatorTime',
    slot: 'time'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 100,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
export default {
  components: {
    SiteSearchGroup,
    addDialog
  },
  data() {
    return {
      params: {
        type: 'ACADEMIC_RANK'
      },
      showAdv: false,
      optionType: PUBLISHER_DICT_OPTION,
      titleTab: [
        { title: 'All', statu: 1 },
        { title: 'Published', statu: 2 },
        { title: 'Draft', statu: 3 }
      ],
      titleStatu: 1,
      dataSource: [],
      columns: columns,
      isVisable: false,
      inputData: {}
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      domain: 'getDomain',
      journalId: 'getJournalId',
      user: 'getUser'
    })
  },
  watch: {},
  mounted() {
    this.getList()
  },
  methods: {
    changeStatus(val) {
      this.titleStatu = val.statu
      switch (val.title) {
        case 'Published':
          this.params.enabled = true
          break
        case 'Draft':
          this.params.enabled = false
          break
        default:
          this.params.enabled = ''
      }
      this.getList()
    },
    async getList() {
      const data = await settingOption.get(this.params)
      this.dataSource = data
    },
    add() {
      this.isVisable = true
      this.inputData = {}
    },
    edit(val) {
      this.inputData = val
      this.isVisable = true
    },
    async able(val) {
      const data = {
        enabled: !val.enabled,
        version: val.version
      }
      await settingOption.enabled(val.id, data)
      this.getList()
    },
    async setSort(val) {
      val.forEach((item, index) => {
        item.sort = index
      })
      await settingOption.setSort(val)
      this.getList()
    },

    cancel() {
      this.isVisable = false
    },
    handleClear() {
      this.params = {
        type: 'ACADEMIC_RANK'
      }
      this.getList()
    },
    async confirm() {
      this.isVisable = false
      this.getList()
    }
  }
}
